export default __webpack_public_path__ + "static/media/app-video.2de14fa5.gif";